import { createApi } from '@reduxjs/toolkit/query/react'
import {
  ImpersonateUserRequest,
  LoginRequest,
  LoginResponse,
  ModuleFunction,
  VerifyTokenResponse,
} from '@/features/auth/auth.def.ts'
import { appPortalBaseQuery } from '@/features/baseQuery.ts'

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: appPortalBaseQuery({
    baseUrl: import.meta.env.VITE_AUTH_SERVICE_BASE_URL,
  }),
  tagTypes: ['Permissions', 'Roles'],
  endpoints: builder => ({
    verifyToken: builder.query<VerifyTokenResponse, void>({
      query: () => ({
        url: '/token/verify',
        method: 'GET',
      }),
    }),
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: arg => ({
        url: `/login/cloudflare/environment/${arg.envName}`,
        method: 'POST',
      }),
      transformErrorResponse: () => {
        return 'Unable to login'
      },
    }),
    impersonateUser: builder.mutation<LoginResponse, ImpersonateUserRequest>({
      query: arg => ({
        url: `/login/cloudflare/environment/${arg.envName}/impersonate/${arg.username}`,
        method: 'POST',
      }),
    }),
    getPermissions: builder.query<{ data: ModuleFunction[] }, void>({
      query: () => ({
        url: '/token/owned-module-function-list',
        method: 'GET',
      }),
      providesTags: ['Permissions'],
    }),
    getRoles: builder.query<{ data: string[] }, void>({
      query: () => ({
        url: '/token/owned-role-list',
        method: 'GET',
      }),
      providesTags: ['Roles'],
    }),
  }),
})

export const {
  useLazyVerifyTokenQuery,
  useLoginMutation,
  useImpersonateUserMutation,
  useLazyGetPermissionsQuery,
  useLazyGetRolesQuery,
  useGetPermissionsQuery,
  useGetRolesQuery,
} = authApi
